import axios from 'axios';

export interface CnpjLookupResponse {
    razao_social: string;
    nome_fantasia?: string | null;
    cep?: string | null;
    logradouro?: string | null;
    numero?: string | null;
    complemento?: string | null;
    bairro?: string | null;
    municipio?: string | null;
    uf?: string | null;
    descricao_situacao_cadastral?: string | null;
}

/// Dados públicos da empresa pelo CNPJ, na BrasilAPI (gratuita, sem chave, devolve o endereço).
/// Axios puro, como no CEP: o token do CRM não pode sair daqui.
export class CnpjLookupService {
    private url = 'https://brasilapi.com.br/api/cnpj/v1';

    public async lookup(cnpj: string) {
        return axios.get<CnpjLookupResponse>(`${this.url}/${cnpj}`);
    }
}
